/**
 * D2(a) — where a result row navigates. Pure so the mapping is unit-tested and shared by the header
 * dropdown (GS-02) and the results page sections.
 *
 * `userSelected` is set for members: the app opens a member's profile via
 * UserProfileContext.setSearchParams({ userSelected }) + /member/overview (the same mechanism the
 * members grid uses), not via a URL id.
 */
import {ResultItem} from './types'

export interface ResultNav {
  path: string
  userSelected?: string
}

export const resultItemPath = (item: ResultItem): ResultNav => {
  switch (item.type) {
    case 'member':
      return {path: '/member/overview', userSelected: String(item.id)}
    case 'experience':
      return {path: `/experience/detail/${item.id}`}
    case 'forum':
    case 'mastermind_circle':
      // Forums and mastermind circles are both CommunityPost → the same detail route.
      return {path: `/community/details/${item.id}`}
    case 'expertise':
      // "Expertise" scope surfaces Partners (partner_type='Expert'). Clicking a result opens
      // the expert's public profile.
      return {path: `/experts/${item.id}`}
    default:
      return {path: '/'}
  }
}
